import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import { Send_SEF_Emails } from "../../Registers/api/Send_SEF_Emails";

function ViewPortalEmails() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([
    // Example customer objects

    {
      BasicInfo: {
        First_Name: "NOT FOUND",
        Created_At: "2024-10-01",
        ProgrammeTitle: "Weekend Programme",
        ProgrammeVarient: "In Person",
        ProgrammeDate: "(3rd November 2024)",
      },
      Notes: [
        //{ Note: "7-day Email Sent", DateTime: "2024-09-12T10:00:00Z" },
        { Note: "72-hour Email Sent", DateTime: "2024-10-01T10:00:00Z" },
        { Note: "24-hour Email Sent", DateTime: "2024-10-04T10:00:00Z" },
        { Note: "Last-day Email Sent", DateTime: "2024-10-05T10:00:00Z" },
      ],
    },

    // Add more customer objects as needed
  ]);

  useEffect(() => {
    // Get_All_From_MongoDB("Registers_2025", "All", setRegisters, logout);
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      {
        ProgrammeTitle: "Weekend",
        ProgrammeVarient: "Person",
        ProgrammeDate: "2025",
        //First_Name: "test",
        //First_Name: "Liesje",
        //First_Name: "Jonathan",

        //Kallumpuram
      },
      10000,
      setRegisters,
      logout
    );
  }, []);

  const emailSequence = [
    "7-day Email Sent",
    "72-hour Email Sent",
    "24-hour Email Sent",
    "Last-day Email Sent",
    "Missed-deadline Email Sent",
  ];

  const emailIntervals = {
    "7-day Email Sent": 4 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
    "72-hour Email Sent": 2 * 24 * 60 * 60 * 1000, // 3 days in milliseconds
    "24-hour Email Sent": 1 * 24 * 60 * 60 * 1000, // 1 day in milliseconds
    "Last-day Email Sent": 1 * 24 * 60 * 60 * 1000, // 1 day in milliseconds
    "Missed-deadline Email Sent": 1 * 24 * 60 * 60 * 1000, // 1 day in milliseconds
  };

  const getFirstEmail = (bookingDate) => {
    // if (bookingDate <= new Date("2024-09-30")) {
    //   return "7-day Email Sent";
    // } else if (bookingDate <= new Date("2024-10-31")) {
    //   return "72-hour Email Sent";
    // } else if (bookingDate <= new Date("2025-03-01")) {
    //   return "24-hour Email Sent";
    // }
    // return null;
    return "7-day Email Sent";
  };

  const getNextEmail = (lastEmail) => {
    const index = emailSequence.indexOf(lastEmail);
    if (index >= 0 && index < emailSequence.length - 1) {
      return emailSequence[index + 1];
    }
    return null;
  };

  const determineDueEmail = (customer) => {
    const bookingDate = new Date(customer.BasicInfo.Created_At);
    const notes = customer.Notes || []; // Default to an empty array if Notes is undefined

    // Filter notes to include only email-related notes
    const emailNotes = notes.filter((note) =>
      emailSequence.includes(note.Note)
    );

    // Filter out customers based on ProgrammeTitle and ProgrammeVarient
    const programmeTitle = customer?.BasicInfo?.ProgrammeTitle || "";
    const programmeVarient = customer?.BasicInfo?.ProgrammeVarient || "";
    const programmeDate = customer?.BasicInfo?.ProgrammeDate || "";
    if (
      !programmeTitle.toLowerCase().includes("weekend") ||
      programmeVarient.toLowerCase().includes("online")
    ) {
      return null;
    }

    // //if programmeDate contains 3rd Nov, return null
    // if (programmeDate.includes("3rd November")) {
    //   return null;
    // }

    // Filter out customers based on complete progress
    const Progress_BasicInfo = customer?.SEFProgress?.BasicInfo;
    const Progress_GeneralInfo = customer?.SEFProgress?.GeneralInfo;
    const Progress_EmergancyMedicalInfo =
      customer?.SEFProgress?.EmergancyMedicalInfo;
    const Progress_SENDInfo = customer?.SEFProgress?.SENDInfo;
    const Progress_ContactInfo = customer?.SEFProgress?.ContactInfo;
    const Progress_PermissionsInfo = customer?.SEFProgress?.PermissionsInfo;

    if (
      Progress_BasicInfo === "Complete" &&
      Progress_GeneralInfo === "Complete" &&
      Progress_EmergancyMedicalInfo === "Complete" &&
      Progress_SENDInfo === "Complete" &&
      Progress_ContactInfo === "Complete" &&
      Progress_PermissionsInfo === "Complete"
    ) {
      return null;
    }

    if (emailNotes.length === 0) {
      return getFirstEmail(bookingDate);
    }

    const lastNote = emailNotes[emailNotes.length - 1];
    const lastEmail = lastNote.Note;
    const lastEmailDate = new Date(lastNote.DateTime);
    const now = new Date();

    if (now - lastEmailDate >= emailIntervals[lastEmail]) {
      return getNextEmail(lastEmail);
    }

    return null;
  };

  const dueEmails = Registers.map((customer) => ({
    customer,
    dueEmail: determineDueEmail(customer),
  }));
  const dueEmailsFiltered = dueEmails.filter((dueEmail) => dueEmail.dueEmail);

  console.log(dueEmailsFiltered);

  //Given an Array notes, see if there is an object with the value of Value in the Note prop
  const FindNote = (notes, Value) => {
    const Notes = notes || [];
    return Notes.find((note) => note.Note === Value);
  };

  function handleSendAll(e) {
    e.preventDefault();
    //filter each customer to keep only the BasicInfo and Contacts
    const customers = dueEmailsFiltered.map((customer) => {
      return {
        _id: customer.customer._id,
        BasicInfo: customer.customer.BasicInfo,
        Password: customer.customer?.MetaData?.Password,
        Contacts: customer.customer.Contacts,
        dueEmail: customer.dueEmail,
      };
    });
    // Filter the contacts array in each customer to only keep those with values in Person of either "Attendee" or "Parent". If there is neither, then the customer is removed. When removed, we log the customer.
    const customersWithContacts = customers.map((customer) => {
      const Contacts = customer.Contacts || [];
      const Attendee = Contacts.find(
        (contact) => contact.Person === "Attendee"
      );
      const Parent = Contacts.find((contact) => contact.Person === "Parent");
      if (Attendee || Parent) {
        return {
          _id: customer._id,
          BasicInfo: customer.BasicInfo,
          Password: customer.Password,
          Contacts: [Attendee, Parent].filter((contact) => contact),
          dueEmail: customer.dueEmail,
        };
      }
      console.log("Customer without Attendee or Parent", customer);
      return null;
    });
    // Filter out customers with no contacts
    const customersWithContactsFiltered = customersWithContacts.filter(
      (customer) => customer
    );
    //loop through each customersWithContactsFiltered and consoel.log each

    customersWithContactsFiltered.forEach((customer) => {
      console.log(customer);
      let newNote = {
        DateTime: new Date().toISOString(),
        Note: customer.dueEmail,
        Staff_ID: localStorage.getItem("_id"),
      };
      console.log(newNote);
      Send_SEF_Emails(customer, newNote, logout);
    });
  }

  //Display if they are compelte or not

  function IsStudentCompelted(customer) {
    const Progress_BasicInfo = customer?.SEFProgress?.BasicInfo;
    const Progress_GeneralInfo = customer?.SEFProgress?.GeneralInfo;
    const Progress_EmergancyMedicalInfo =
      customer?.SEFProgress?.EmergancyMedicalInfo;
    const Progress_SENDInfo = customer?.SEFProgress?.SENDInfo;
    const Progress_ContactInfo = customer?.SEFProgress?.ContactInfo;
    const Progress_PermissionsInfo = customer?.SEFProgress?.PermissionsInfo;

    if (
      Progress_BasicInfo === "Complete" &&
      Progress_GeneralInfo === "Complete" &&
      Progress_EmergancyMedicalInfo === "Complete" &&
      Progress_SENDInfo === "Complete" &&
      Progress_ContactInfo === "Complete" &&
      Progress_PermissionsInfo === "Complete"
    ) {
      return "Complete";
    }
    return "Incomplete";
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            View IP Weekend Emails
          </Typography>
          <button style={{ width: "100px" }} onClick={(e) => handleSendAll(e)}>
            Send
          </button>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <>{SimpleTableHeader("_id")}</>
                  <>{SimpleTableHeader("Created At")}</>
                  <>{SimpleTableHeader("Order")}</>
                  <>{SimpleTableHeader("First Name")}</>
                  <>{SimpleTableHeader("Last Name")}</>
                  <>{SimpleTableHeader("Title")}</>
                  <>{SimpleTableHeader("Date")}</>
                  <>{SimpleTableHeader("Varient")}</>
                  {emailSequence.map((email, index) => (
                    <>{SimpleTableHeader("Got " + email + " ?")}</>
                  ))}
                  <>{SimpleTableHeader("Email Due")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Register, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Register?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Register?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    {SimpleTableCell(Register?._id)}
                    {SimpleTableCell(Register?.BasicInfo?.Created_At)}
                    {SimpleTableCell(Register?.OrderInfo?.OriginalOrderNumber)}
                    {SimpleTableCell(Register?.BasicInfo?.First_Name)}
                    {SimpleTableCell(Register?.BasicInfo?.Last_Name)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeTitle)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeDate)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeVarient)}
                    {SimpleTableCell(
                      FindNote(Register?.Notes, "7-day Email Sent")?.Note
                    )}
                    {SimpleTableCell(
                      FindNote(Register?.Notes, "72-hour Email Sent")?.Note
                    )}
                    {SimpleTableCell(
                      FindNote(Register?.Notes, "24-hour Email Sent")?.Note
                    )}
                    {SimpleTableCell(
                      FindNote(Register?.Notes, "Last-day Email Sent")?.Note
                    )}
                    {SimpleTableCell(
                      FindNote(Register?.Notes, "Missed-deadline Email Sent")
                        ?.Note
                    )}
                    {SimpleTableCell(determineDueEmail(Register))}
                    {SimpleTableCell(IsStudentCompelted(Register))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default ViewPortalEmails;
